import { useNavigate } from 'react-router-dom';

import Page from '@/components/layout/Page';
import HeaderWithBack from '@/components/common/HeaderWithBack';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

import ChangePasswordForm from './components/userProfilePage/ChangePasswordForm';

const UserProfilePage = () => {
  const navigate = useNavigate();

  const handleEditSuccess = () => {
    navigate('/setting');
  };

  return (
    <Page>
      <HeaderWithBack to="/setting" title="Settings" />
      <Card>
        <CardHeader>
          <CardTitle>Edit Profile</CardTitle>
        </CardHeader>
        <CardContent>
          <ChangePasswordForm onSuccess={handleEditSuccess} />
        </CardContent>
      </Card>
      <div className="flex justify-center py-8"></div>
    </Page>
  );
};

export default UserProfilePage;
